<template>
  <OrderPageSection v-if="[30, 40, 50, 60, 80].includes(order.status)">
    <div class="order-page-label upload-pos">
      {{ isCreator ? "上传小票" : "上传小票" }}
    </div>
    <ImageUploader
      :value="value"
      :max-count="9"
      :disabled="disabled"
      @input="(v) => $emit('input', v)"
      @upload="$emit('update', true)"
      @remove="$emit('update', false)"
    />
  </OrderPageSection>
</template>

<script>
import OrderPageSection from "../widgets/OrderPageSection.vue";
import ImageUploader from "@/components/common/ImageUploader.vue";

export default {
  components: { OrderPageSection, ImageUploader },
  props: {
    order: Object,
    value: Array,
    isCreator: Boolean,
    disabled: Boolean,
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.order-page-label {
  height: 49/20rem;
  padding: 20/20rem 0 12/20rem;
  line-height: 17/20rem;
  font-weight: 500;
  font-size: 12/20rem;
  letter-spacing: 0;
  color: #000;
}
</style>
